import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';

import { get_problema_thread } from '../api';
import { RispondiProblemaNumerico, RispondiProblemaMultiplo, LoadingCircle } from '../components';
import { useLogin } from '../reducers';
import { login_url } from '../globals';

type Thread = Awaited<ReturnType<typeof get_problema_thread>>

const RispondiProblema = (props: {}) => {
  const params = useParams<{ pk: string }>();
  const pk = parseInt(params.pk as string);
  const [thread, setThread] = useState<Thread | null>(null);
  const login = useLogin();


  useEffect(() => {
    document.title = "Rispondi problema - Owlitrack";
    fetch_data();
  }, [])

  if (!login.logged_in) {
    login_url()
  }


  const fetch_data = () => {
    get_problema_thread(pk).then(setThread)
  }

  useEffect(() => {
    fetch_data()
  }, [pk])

  if (!thread) {
    return <LoadingCircle />
  }

  if (thread.problema.tipologia_risposta === "num") {
    return <RispondiProblemaNumerico thread={thread} />
  } else if (thread.problema.tipologia_risposta == "mul") {
    return <RispondiProblemaMultiplo thread={thread} />
  } else {
    // return <RispondiProblemaAperto />
  }
}


export default RispondiProblema;
